/*!

 File: set-nav-mobile.js
 Author: Ember
 Version: 1.0.1
 JS Dependencies:
    'closest' polyfill
    'on' helper

 CSS Dependencies:

 Description:
     Open close navigation
*/

var setNavMobile = {
    btnClick: null, // Event handler
    clickOutside: null,  // Event handler
    advanceSubNav: null,  // Event handler
    init: function (elNav) {

        var me = setNavMobile;
        var elHeader = document.querySelector('.header');
        var elNavUl = elNav.querySelector('ul');
        var elChildUls = elNavUl.querySelectorAll('ul');
        var elBtn = document.querySelector('.js-mobile-nav-btn');
        var menuPos = 0; // subnav menu position

        // Get menu height for open anim
        var menuHeight = elNavUl.offsetHeight;

        // Open nav function
        var openNav = function(e){
            e.preventDefault();
            // Show overlay
            setOverlay.show();
            // show nav
            elNav.style.height = 'auto';
            elNav.style.maxHeight = menuHeight + 'px';
            // Show as open
            elHeader.classList.add('nav-open');
            // menu outside click event
            setTimeout(function(){
                on('click', document, me.clickOutside);
            }, 200);
        }

        // Close nav function
        var closeNav = function(e){
            e.preventDefault();
            // remove menu outside click event
            off('click', document, me.clickOutside);
            // Hide overlay
            setOverlay.hide();
            // Close nav
            elNav.style.height = 'auto';
            elNav.style.maxHeight = 0;
            // Show as closed
            elHeader.classList.remove('nav-open');
            // Reset Subs
            setTimeout(function(){
                // hide all children
                hideAllChildren();
                elNav.classList.remove('menu-pos-' + menuPos);
                menuPos=0;
            }, 400);
        }

        // Click event - outside close menu
        me.clickOutside = function(e){

            // Don't run if right-click or command/control + click
            if (e.button !== 0) return;

            // Closest captures self as well a parents
            if (e.target.closest('.js-mobile-nav') || e.target.closest('.logo') ) return;

            // Button clicked
            e.preventDefault();

            // close nav
            closeNav(e);
        }

        // Click event - menu button
        me.btnClick = function(e){
            if(elHeader.classList.contains('nav-open')){
                closeNav(e);
            }else{
                openNav(e);
            }
        };

        // Menu Button click event
        on('click', elBtn, me.btnClick);



        // Add back button
        if(elChildUls && elChildUls.length>0){
            forEachNode(elChildUls, function (i, el) {
                // Check if already exists
                var elBack = el.querySelector('.js-sub-back');
                if(!elBack){
                    // create LI
                    var newLi = document.createElement('li');
                    newLi.classList.add('li-sub-back');
                    // Add back link
                    newLi.innerHTML = '<a href="#" class="icon-sub-back js-sub-back"><span>Back<\/span><\/a>';
                    // Put at top of list
                    el.insertBefore(newLi, el.firstChild);
                }
            });
        }

        // Hide all children
        var hideAllChildren = function(){
            if(elChildUls && elChildUls.length>0){
                forEachNode(elChildUls, function (i, el) {
                    el.parentNode.classList.remove('show-child');
                });
            }
        }

        // Move menu
        var moveSubNav = function(dir){
            elNav.classList.remove('menu-pos-' + menuPos);
            menuPos+= dir;
            elNav.classList.add('menu-pos-' + menuPos);
        }

        // Click event - sub menu link
        me.advanceSubNav = function(e){
            // Don't run if right-click or command/control + click
            if (e.button !== 0) return;

            // Could be span clicked so get closest A
            var elLink = e.target.closest('a');

            // If not an A end
            if (!elLink) return;

            // Get parent LI
            var elLi = elLink.parentNode;

            // Move forwards
            if(elLi.classList.contains('menu-item-has-children')) {
                e.preventDefault();
                // Hide all subs
                hideAllChildren();
                // Show correct sub UL
                var elChildUl = elLi.querySelector('ul');
                elLi.classList.add('show-child');
                // Move nav forwards
                moveSubNav(1);
            }

            // Move backwards
            if(elLink.classList.contains('js-sub-back')) {
                e.preventDefault();
                // Move nav backwards
                moveSubNav(-1);
            }

        }

        // Sub menu click event
        on('click', elNavUl, me.advanceSubNav);

    },
    destroy: function (elNav) {
        var me = setNavMobile;

        var elNavUl = elNav.querySelector('ul');
        var elBtn = document.querySelector('.js-mobile-nav-btn');
        var elHeader = document.querySelector('.header');

        // Hide overlay
        setOverlay.hide();

        // Remove menu outside click event
        off('click', document, me.clickOutside);

        // Remove menu Button click event
        off('click', elBtn, me.btnClick);

        // Remove sub menu click event
        off('click', elNavUl, me.advanceSubNav);

        elHeader.classList.remove('nav-open');

        // Reset inline styles
        elNav.style.height = '';
        elNav.style.maxHeight = '';

        // Reset sub menus
        var elVisible = elNavUl.querySelector('.show-child');
        if(elVisible){
            elVisible.classList.remove('show-child');
        }
        elNav.classList.remove('menu-pos-0', 'menu-pos-1', 'menu-pos-2');

    }
}
